import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import EmployeeService from "services/EmployeeService";

export const getEmployee = createAsyncThunk(
  "employee/getEmployee",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.getEmployee(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getEmployeeV2 = createAsyncThunk(
  "employee/getEmployeeV2",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.getEmployeeV2(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const createEmployeeApi = createAsyncThunk(
  "employee/createEmployee",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await EmployeeService.createEmployee(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateEmployeeApi = createAsyncThunk(
  "employee/updateEmployee",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await EmployeeService.updateEmployee(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const delEmployeeApi = createAsyncThunk(
  "employee/delEmployeeApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await EmployeeService.delEmployee(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const delAccountApi = createAsyncThunk(
  "employee/delEmployeeApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      delete data.onSuccess;
      const response = await EmployeeService.delAccountApi(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const changeStatusEmployee = createAsyncThunk(
  "employee/changeStatusEmployee",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.changeStatusEmployee(data);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  employeeList: [],
};
export const storeEmployeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setEmployee: (state, action) => {
      state.employeeList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeList = action.payload;
      })
      .addCase(getEmployee.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getEmployeeV2.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEmployeeV2.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeList = action.payload;
      })
      .addCase(getEmployeeV2.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createEmployeeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createEmployeeApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createEmployeeApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateEmployeeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEmployeeApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateEmployeeApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(delEmployeeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(delEmployeeApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(delEmployeeApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStatusEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeStatusEmployee.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStatusEmployee.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setEmployee } = storeEmployeeSlice.actions;

export default storeEmployeeSlice.reducer;
